<div class="download-app-container">
  <div class="top-content">
    <div class="image-container">
      <img data-src="/assets/images/home-v2/mcd-app-homepage_v3.png" loading="lazy" alt="mcd image" />
    </div>
    <div class="right-content">
      <div class="cards" *ngFor="let item of mcdListData">
        <div class="icon">
          <img [src]="item?.iconPath" alt="mcd image">
        </div>
        <div class="content">
          <span class="title">
            {{item?.title}}
          </span>
          <span class="desc" *ngIf="!isMobile">
            {{item?.desc}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="cta-container">
  <span class="app-text">
    Get the Ketto App to track your campaign effortlessly.
  </span>
  <div class="btn-container">
    <ng-container *ngIf="!isMobile">
      <a [href]="vars.appLink.android_mcd" target="_blank" (click)="systemEvents('android')">
        <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/icons/black-google-store.png" alt="no image" />
        <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/google-download.png" alt="no image">
      </a>
      <a [href]="vars.appLink.iOS_mcd" target="_blank" (click)="systemEvents('iOS')">
        <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/App-Store-black.png" alt="no image" />
        <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" data-src="/assets/images/sip/App-Store.png" alt="no image">
      </a>
    </ng-container>
    <ng-container *ngIf="isMobile">
      <img *ngIf="!config?.v?.toString()?.match('6')" loading="lazy" [attr.data-src]="isIos ? '/assets/images/sip/App-Store-black.png' : '/assets/images/sip/icons/black-google-store.png'" alt="no image" />
      <img *ngIf="config?.v?.toString()?.match('6')" loading="lazy" [attr.data-src]="isIos ? '/assets/images/sip/App-Store.png' : '/assets/images/sip/google-download.png'" alt="no image" />
    </ng-container>
  </div>
</div>